import React, { useId } from 'react';
import { normalizeOtp } from '../utils/otp';

// One real, visible input lets iOS, Android keyboards and paste insert the whole code.
export default function OtpInput({ value, onChange, disabled = false }) {
  const id = useId();
  return (
    <div className="flex flex-col items-center gap-2" dir="rtl">
      <label htmlFor={id} className="text-sm text-gray-600">کد تأیید ۵ رقمی</label>
      <input
        id={id}
        name="verification_code"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus
        autoCapitalize="none"
        spellCheck={false}
        dir="ltr"
        pattern="[0-9]{5}"
        maxLength={5}
        value={value}
        onChange={event => onChange(normalizeOtp(event.target.value))}
        onPaste={event => {
          const pasted = event.clipboardData.getData('text');
          const code = normalizeOtp(pasted);
          if (code) { event.preventDefault(); onChange(code); }
        }}
        disabled={disabled}
        required
        className="w-full max-w-xs h-16 text-2xl font-bold text-center tracking-[0.5em] bg-white border-2 border-gray-300 rounded-2xl focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 transition-all shadow-sm"
      />
    </div>
  );
}
